/**
 * WHO / IAP growth chart reference data.
 * Raw data: { Month, p3, p10, p25, p50, p75, p90, p97 }.
 * Ages for chart = Month / 12 (years). Curves = 7 percentiles, no calculation.
 */

const PERCENTILE_LABELS_7 = ['3rd', '10th', '25th', '50th', '75th', '90th', '97th'];
const PERCENTILE_LABELS_4 = ['3rd', '10th', '50th', '97th'];
const PERCENTILE_LABELS_HC_7 = ['3rd', '10th', '25th', '50th', '75th', '90th', '97th'];

// Ages 0-5 only (61 points) for BMI and Head Circumference
const AGE_0_5_YEARS = Array.from({ length: 61 }, (_, i) => i / 12);

// Helper: build { ages, curves } from raw table (Month, p3, p10, p25, p50, p75, p90, p97)
function buildFromRawTable(raw, labels = PERCENTILE_LABELS_7) {
  const ages = raw.map(r => r.Month / 12);
  const pKeys = ['p3', 'p10', 'p25', 'p50', 'p75', 'p90', 'p97'];
  const curves = labels.map((label, i) => ({
    label,
    value: raw.map(r => r[pKeys[i]])
  }));
  return { ages, curves };
}

// ========== 1. Girls Height WHO IAP Blended (raw table: Month 0–60, then 66–216) ==========
const GIRLS_HEIGHT_RAW = [
  { Month: 0, p3: 45.6, p10: 46.8, p25: 47.9, p50: 49.1, p75: 50.4, p90: 51.5, p97: 52.7 },
  { Month: 1, p3: 50.0, p10: 51.2, p25: 52.4, p50: 53.7, p75: 55.0, p90: 56.2, p97: 57.4 },
  { Month: 2, p3: 53.2, p10: 54.5, p25: 55.7, p50: 57.1, p75: 58.4, p90: 59.7, p97: 60.9 },
  { Month: 3, p3: 55.8, p10: 57.1, p25: 58.4, p50: 59.8, p75: 61.2, p90: 62.5, p97: 63.8 },
  { Month: 4, p3: 58.0, p10: 59.3, p25: 60.6, p50: 62.1, p75: 63.5, p90: 64.9, p97: 66.2 },
  { Month: 5, p3: 59.9, p10: 61.2, p25: 62.5, p50: 64.0, p75: 65.5, p90: 66.9, p97: 68.2 },
  { Month: 6, p3: 61.5, p10: 62.8, p25: 64.2, p50: 65.7, p75: 67.3, p90: 68.6, p97: 70.0 },
  { Month: 7, p3: 62.9, p10: 64.3, p25: 65.7, p50: 67.3, p75: 68.8, p90: 70.3, p97: 71.6 },
  { Month: 8, p3: 64.3, p10: 65.7, p25: 67.2, p50: 68.7, p75: 70.3, p90: 71.8, p97: 73.2 },
  { Month: 9, p3: 65.6, p10: 67.0, p25: 68.5, p50: 70.1, p75: 71.8, p90: 73.2, p97: 74.7 },
  { Month: 10, p3: 66.8, p10: 68.3, p25: 69.8, p50: 71.5, p75: 73.1, p90: 74.6, p97: 76.1 },
  { Month: 11, p3: 68.0, p10: 69.5, p25: 71.1, p50: 72.8, p75: 74.5, p90: 76.0, p97: 77.5 },
  { Month: 12, p3: 69.2, p10: 70.7, p25: 72.3, p50: 74.0, p75: 75.8, p90: 77.3, p97: 78.9 },
  { Month: 13, p3: 70.3, p10: 71.8, p25: 73.4, p50: 75.2, p75: 77.0, p90: 78.6, p97: 80.2 },
  { Month: 14, p3: 71.3, p10: 72.9, p25: 74.6, p50: 76.4, p75: 78.2, p90: 79.8, p97: 81.4 },
  { Month: 15, p3: 72.4, p10: 74.0, p25: 75.7, p50: 77.5, p75: 79.4, p90: 81.0, p97: 82.7 },
  { Month: 16, p3: 73.3, p10: 75.0, p25: 76.7, p50: 78.6, p75: 80.5, p90: 82.2, p97: 83.9 },
  { Month: 17, p3: 74.3, p10: 76.0, p25: 77.7, p50: 79.7, p75: 81.6, p90: 83.3, p97: 85.0 },
  { Month: 18, p3: 75.2, p10: 77.0, p25: 78.7, p50: 80.7, p75: 82.7, p90: 84.4, p97: 86.2 },
  { Month: 19, p3: 76.2, p10: 77.9, p25: 79.7, p50: 81.7, p75: 83.7, p90: 85.5, p97: 87.3 },
  { Month: 20, p3: 77.0, p10: 78.8, p25: 80.7, p50: 82.7, p75: 84.7, p90: 86.6, p97: 88.4 },
  { Month: 21, p3: 77.9, p10: 79.7, p25: 81.6, p50: 83.7, p75: 85.7, p90: 87.6, p97: 89.4 },
  { Month: 22, p3: 78.7, p10: 80.6, p25: 82.5, p50: 84.6, p75: 86.7, p90: 88.6, p97: 90.5 },
  { Month: 23, p3: 79.6, p10: 81.5, p25: 83.4, p50: 85.5, p75: 87.7, p90: 89.6, p97: 91.5 },
  { Month: 24, p3: 79.6, p10: 81.6, p25: 83.5, p50: 85.7, p75: 87.9, p90: 89.9, p97: 91.8 },
  { Month: 25, p3: 80.4, p10: 82.4, p25: 84.4, p50: 86.6, p75: 88.8, p90: 90.8, p97: 92.8 },
  { Month: 26, p3: 81.2, p10: 83.2, p25: 85.2, p50: 87.4, p75: 89.7, p90: 91.7, p97: 93.7 },
  { Month: 27, p3: 81.9, p10: 83.9, p25: 86.0, p50: 88.3, p75: 90.6, p90: 92.6, p97: 94.6 },
  { Month: 28, p3: 82.6, p10: 84.7, p25: 86.8, p50: 89.1, p75: 91.4, p90: 93.5, p97: 95.6 },
  { Month: 29, p3: 83.4, p10: 85.4, p25: 87.6, p50: 89.9, p75: 92.2, p90: 94.4, p97: 96.4 },
  { Month: 30, p3: 84.0, p10: 86.2, p25: 88.3, p50: 90.7, p75: 93.1, p90: 95.2, p97: 97.3 },
  { Month: 31, p3: 84.7, p10: 86.9, p25: 89.0, p50: 91.4, p75: 93.9, p90: 96.0, p97: 98.2 },
  { Month: 32, p3: 85.4, p10: 87.5, p25: 89.7, p50: 92.2, p75: 94.6, p90: 96.8, p97: 99.0 },
  { Month: 33, p3: 86.0, p10: 88.2, p25: 90.4, p50: 92.9, p75: 95.4, p90: 97.6, p97: 99.8 },
  { Month: 34, p3: 86.7, p10: 88.9, p25: 91.1, p50: 93.6, p75: 96.2, p90: 98.4, p97: 100.6 },
  { Month: 35, p3: 87.3, p10: 89.5, p25: 91.8, p50: 94.4, p75: 96.9, p90: 99.2, p97: 101.4 },
  { Month: 36, p3: 87.9, p10: 90.2, p25: 92.5, p50: 95.1, p75: 97.6, p90: 99.9, p97: 102.2 },
  { Month: 37, p3: 88.5, p10: 90.8, p25: 93.1, p50: 95.7, p75: 98.3, p90: 100.7, p97: 103.0 },
  { Month: 38, p3: 89.1, p10: 91.4, p25: 93.8, p50: 96.4, p75: 99.0, p90: 101.4, p97: 103.7 },
  { Month: 39, p3: 89.7, p10: 92.0, p25: 94.4, p50: 97.1, p75: 99.7, p90: 102.1, p97: 104.5 },
  { Month: 40, p3: 90.3, p10: 92.6, p25: 95.1, p50: 97.7, p75: 100.4, p90: 102.9, p97: 105.2 },
  { Month: 41, p3: 90.8, p10: 93.2, p25: 95.7, p50: 98.4, p75: 101.1, p90: 103.6, p97: 106.0 },
  { Month: 42, p3: 91.4, p10: 93.8, p25: 96.3, p50: 99.0, p75: 101.8, p90: 104.3, p97: 106.7 },
  { Month: 43, p3: 92.0, p10: 94.4, p25: 96.9, p50: 99.7, p75: 102.4, p90: 104.9, p97: 107.4 },
  { Month: 44, p3: 92.5, p10: 95.0, p25: 97.5, p50: 100.3, p75: 103.1, p90: 105.6, p97: 108.1 },
  { Month: 45, p3: 93.0, p10: 95.6, p25: 98.1, p50: 100.9, p75: 103.7, p90: 106.3, p97: 108.8 },
  { Month: 46, p3: 93.6, p10: 96.1, p25: 98.7, p50: 101.5, p75: 104.4, p90: 107.0, p97: 109.5 },
  { Month: 47, p3: 94.1, p10: 96.7, p25: 99.3, p50: 102.1, p75: 105.0, p90: 107.6, p97: 110.2 },
  { Month: 48, p3: 94.6, p10: 97.2, p25: 99.8, p50: 102.7, p75: 105.6, p90: 108.3, p97: 110.8 },
  { Month: 49, p3: 95.1, p10: 97.8, p25: 100.4, p50: 103.3, p75: 106.3, p90: 108.9, p97: 111.5 },
  { Month: 50, p3: 95.7, p10: 98.3, p25: 100.9, p50: 103.9, p75: 106.9, p90: 109.5, p97: 112.1 },
  { Month: 51, p3: 96.2, p10: 98.8, p25: 101.5, p50: 104.5, p75: 107.5, p90: 110.1, p97: 112.8 },
  { Month: 52, p3: 96.7, p10: 99.3, p25: 102.0, p50: 105.0, p75: 108.1, p90: 110.8, p97: 113.4 },
  { Month: 53, p3: 97.2, p10: 99.9, p25: 102.6, p50: 105.6, p75: 108.6, p90: 111.4, p97: 114.1 },
  { Month: 54, p3: 97.6, p10: 100.4, p25: 103.1, p50: 106.2, p75: 109.2, p90: 112.0, p97: 114.7 },
  { Month: 55, p3: 98.1, p10: 100.9, p25: 103.6, p50: 106.7, p75: 109.8, p90: 112.6, p97: 115.3 },
  { Month: 56, p3: 98.6, p10: 101.4, p25: 104.2, p50: 107.3, p75: 110.4, p90: 113.2, p97: 116.0 },
  { Month: 57, p3: 99.1, p10: 101.9, p25: 104.7, p50: 107.8, p75: 111.0, p90: 113.8, p97: 116.6 },
  { Month: 58, p3: 99.6, p10: 102.4, p25: 105.2, p50: 108.4, p75: 111.5, p90: 114.4, p97: 117.2 },
  { Month: 59, p3: 100.0, p10: 102.8, p25: 105.7, p50: 108.9, p75: 112.1, p90: 114.9, p97: 117.8 },
  { Month: 60, p3: 100.5, p10: 103.3, p25: 106.2, p50: 109.4, p75: 112.6, p90: 115.5, p97: 118.4 },
  { Month: 66, p3: 101.4, p10: 104.65, p25: 107.95, p50: 111.45, p75: 115.0, p90: 118.5, p97: 122.0 },
  { Month: 72, p3: 101.85, p10: 105.33, p25: 108.83, p50: 112.47, p75: 116.2, p90: 120.0, p97: 123.8 },
  { Month: 78, p3: 104.9, p10: 108.7, p25: 112.5, p50: 116.5, p75: 120.5, p90: 124.6, p97: 128.7 },
  { Month: 84, p3: 107.4, p10: 111.4, p25: 115.4, p50: 119.4, p75: 123.5, p90: 127.7, p97: 131.9 },
  { Month: 90, p3: 110.0, p10: 114.1, p25: 118.2, p50: 122.4, p75: 126.6, p90: 130.8, p97: 135.0 },
  { Month: 96, p3: 112.6, p10: 116.8, p25: 121.1, p50: 125.4, p75: 129.6, p90: 133.9, p97: 138.1 },
  { Month: 102, p3: 115.2, p10: 119.6, p25: 124.0, p50: 128.4, p75: 132.7, p90: 137.0, p97: 141.3 },
  { Month: 108, p3: 117.8, p10: 122.4, p25: 126.9, p50: 131.4, p75: 135.8, p90: 140.2, p97: 144.5 },
  { Month: 114, p3: 120.5, p10: 125.2, p25: 129.9, p50: 134.4, p75: 138.9, p90: 143.3, p97: 147.6 },
  { Month: 120, p3: 123.3, p10: 128.1, p25: 132.8, p50: 137.4, p75: 142.0, p90: 146.4, p97: 150.8 },
  { Month: 126, p3: 126.1, p10: 130.9, p25: 135.7, p50: 140.4, p75: 145.0, p90: 149.5, p97: 153.9 },
  { Month: 132, p3: 128.8, p10: 133.7, p25: 138.6, p50: 143.3, p75: 147.9, p90: 152.4, p97: 156.8 },
  { Month: 138, p3: 131.5, p10: 136.4, p25: 141.2, p50: 145.9, p75: 150.6, p90: 155.1, p97: 159.6 },
  { Month: 144, p3: 134.0, p10: 138.9, p25: 143.7, p50: 148.4, p75: 153.0, p90: 157.5, p97: 162.0 },
  { Month: 150, p3: 136.3, p10: 141.1, p25: 145.8, p50: 150.5, p75: 155.1, p90: 159.6, p97: 164.1 },
  { Month: 156, p3: 138.2, p10: 142.9, p25: 147.6, p50: 152.2, p75: 156.8, p90: 161.3, p97: 165.9 },
  { Month: 162, p3: 139.9, p10: 144.5, p25: 149.1, p50: 153.6, p75: 158.2, p90: 162.7, p97: 167.2 },
  { Month: 168, p3: 141.3, p10: 145.8, p25: 150.2, p50: 154.7, p75: 159.2, p90: 163.7, p97: 168.2 },
  { Month: 174, p3: 142.4, p10: 146.8, p25: 151.1, p50: 155.5, p75: 160.0, p90: 164.5, p97: 169.0 },
  { Month: 180, p3: 143.3, p10: 147.5, p25: 151.8, p50: 156.1, p75: 160.5, p90: 165.0, p97: 169.5 },
  { Month: 186, p3: 144.1, p10: 148.1, p25: 152.3, p50: 156.6, p75: 160.9, p90: 165.3, p97: 169.8 },
  { Month: 192, p3: 144.7, p10: 148.6, p25: 152.7, p50: 156.9, p75: 161.2, p90: 165.6, p97: 170.1 },
  { Month: 198, p3: 145.2, p10: 149.1, p25: 153.1, p50: 157.2, p75: 161.4, p90: 165.7, p97: 170.2 },
  { Month: 204, p3: 145.7, p10: 149.5, p25: 153.4, p50: 157.4, p75: 161.6, p90: 165.9, p97: 170.4 },
  { Month: 210, p3: 146.2, p10: 149.8, p25: 153.6, p50: 157.6, p75: 161.7, p90: 166.0, p97: 170.5 },
  { Month: 216, p3: 146.6, p10: 150.2, p25: 153.9, p50: 157.8, p75: 161.9, p90: 166.1, p97: 170.6 }
];

// Ages 0–18 for height/weight (same month grid as GIRLS_HEIGHT_RAW: 0–60 then 66–216)
const HEIGHT_WEIGHT_AGES = GIRLS_HEIGHT_RAW.map(r => r.Month / 12);

function buildCurvesFromMatrix(matrix, labels) {
  const curves = labels.map((label, i) => ({
    label,
    value: matrix.map(row => row[i])
  }));
  return curves;
}

// ========== Boys Height WHO & IAP Blended (raw table: Month 0–60, then 66–216) ==========
const BOYS_HEIGHT_RAW = [
  { Month: 0, p3: 46.3, p10: 47.5, p25: 48.6, p50: 49.9, p75: 51.2, p90: 52.3, p97: 53.4 },
  { Month: 1, p3: 51.1, p10: 52.2, p25: 53.4, p50: 54.7, p75: 56, p90: 57.2, p97: 58.4 },
  { Month: 2, p3: 54.7, p10: 55.9, p25: 57.1, p50: 58.4, p75: 59.8, p90: 61, p97: 62.2 },
  { Month: 3, p3: 57.6, p10: 58.8, p25: 60.1, p50: 61.4, p75: 62.8, p90: 64, p97: 65.3 },
  { Month: 4, p3: 60, p10: 61.2, p25: 62.5, p50: 63.9, p75: 65.3, p90: 66.6, p97: 67.8 },
  { Month: 5, p3: 61.9, p10: 63.2, p25: 64.5, p50: 65.9, p75: 67.3, p90: 68.6, p97: 69.9 },
  { Month: 6, p3: 63.6, p10: 64.9, p25: 66.2, p50: 67.6, p75: 69.1, p90: 70.4, p97: 71.6 },
  { Month: 7, p3: 65.1, p10: 66.4, p25: 67.7, p50: 69.2, p75: 70.6, p90: 71.9, p97: 73.2 },
  { Month: 8, p3: 66.5, p10: 67.8, p25: 69.1, p50: 70.6, p75: 72.1, p90: 73.4, p97: 74.7 },
  { Month: 9, p3: 67.7, p10: 69.1, p25: 70.5, p50: 72, p75: 73.5, p90: 74.8, p97: 76.2 },
  { Month: 10, p3: 69, p10: 70.4, p25: 71.7, p50: 73.3, p75: 74.8, p90: 76.2, p97: 77.6 },
  { Month: 11, p3: 70.2, p10: 71.6, p25: 73, p50: 74.5, p75: 76.1, p90: 77.5, p97: 78.9 },
  { Month: 12, p3: 71.3, p10: 72.7, p25: 74.1, p50: 75.7, p75: 77.4, p90: 78.8, p97: 80.2 },
  { Month: 13, p3: 72.4, p10: 73.8, p25: 75.3, p50: 76.9, p75: 78.6, p90: 80, p97: 81.5 },
  { Month: 14, p3: 73.4, p10: 74.9, p25: 76.4, p50: 78, p75: 79.7, p90: 81.2, p97: 82.7 },
  { Month: 15, p3: 74.4, p10: 75.9, p25: 77.4, p50: 79.1, p75: 80.9, p90: 82.4, p97: 83.9 },
  { Month: 16, p3: 75.4, p10: 76.9, p25: 78.5, p50: 80.2, p75: 82, p90: 83.5, p97: 85.1 },
  { Month: 17, p3: 76.3, p10: 77.9, p25: 79.5, p50: 81.2, p75: 83, p90: 84.6, p97: 86.2 },
  { Month: 18, p3: 77.2, p10: 78.8, p25: 80.4, p50: 82.3, p75: 84.1, p90: 85.7, p97: 87.3 },
  { Month: 19, p3: 78.1, p10: 79.7, p25: 81.4, p50: 83.2, p75: 85.1, p90: 86.8, p97: 88.4 },
  { Month: 20, p3: 78.9, p10: 80.6, p25: 82.3, p50: 84.2, p75: 86.1, p90: 87.8, p97: 89.5 },
  { Month: 21, p3: 79.7, p10: 81.5, p25: 83.2, p50: 85.1, p75: 87.1, p90: 88.8, p97: 90.5 },
  { Month: 22, p3: 80.5, p10: 82.3, p25: 84.1, p50: 86, p75: 88, p90: 89.8, p97: 91.6 },
  { Month: 23, p3: 81.3, p10: 83.1, p25: 84.9, p50: 86.9, p75: 89, p90: 90.8, p97: 92.6 },
  { Month: 24, p3: 81.4, p10: 83.2, p25: 85.1, p50: 87.1, p75: 89.2, p90: 91, p97: 92.9 },
  { Month: 25, p3: 82.1, p10: 84, p25: 85.9, p50: 88, p75: 90.1, p90: 92, p97: 93.8 },
  { Month: 26, p3: 82.8, p10: 84.7, p25: 86.7, p50: 88.8, p75: 90.9, p90: 92.9, p97: 94.8 },
  { Month: 27, p3: 83.5, p10: 85.5, p25: 87.4, p50: 89.6, p75: 91.8, p90: 93.8, p97: 95.7 },
  { Month: 28, p3: 84.2, p10: 86.2, p25: 88.2, p50: 90.4, p75: 92.6, p90: 94.6, p97: 96.6 },
  { Month: 29, p3: 84.9, p10: 86.9, p25: 88.9, p50: 91.2, p75: 93.4, p90: 95.5, p97: 97.5 },
  { Month: 30, p3: 85.5, p10: 87.6, p25: 89.6, p50: 91.9, p75: 94.2, p90: 96.3, p97: 98.3 },
  { Month: 31, p3: 86.2, p10: 88.2, p25: 90.3, p50: 92.7, p75: 95, p90: 97.1, p97: 99.2 },
  { Month: 32, p3: 86.8, p10: 88.9, p25: 91, p50: 93.4, p75: 95.7, p90: 97.9, p97: 100 },
  { Month: 33, p3: 87.4, p10: 89.5, p25: 91.7, p50: 94.1, p75: 96.5, p90: 98.6, p97: 100.8 },
  { Month: 34, p3: 88, p10: 90.1, p25: 92.3, p50: 94.8, p75: 97.2, p90: 99.4, p97: 101.5 },
  { Month: 35, p3: 88.5, p10: 90.7, p25: 93, p50: 95.4, p75: 97.9, p90: 100.1, p97: 102.3 },
  { Month: 36, p3: 89.1, p10: 91.3, p25: 93.6, p50: 96.1, p75: 98.6, p90: 100.8, p97: 103.1 },
  { Month: 37, p3: 89.7, p10: 91.9, p25: 94.2, p50: 96.7, p75: 99.3, p90: 101.5, p97: 103.8 },
  { Month: 38, p3: 90.2, p10: 92.5, p25: 94.8, p50: 97.4, p75: 99.9, p90: 102.2, p97: 104.5 },
  { Month: 39, p3: 90.8, p10: 93.1, p25: 95.4, p50: 98, p75: 100.6, p90: 102.9, p97: 105.2 },
  { Month: 40, p3: 91.3, p10: 93.7, p25: 96, p50: 98.6, p75: 101.3, p90: 103.6, p97: 105.9 },
  { Month: 41, p3: 91.9, p10: 94.2, p25: 96.6, p50: 99.2, p75: 101.9, p90: 104.3, p97: 106.6 },
  { Month: 42, p3: 92.4, p10: 94.8, p25: 97.2, p50: 99.9, p75: 102.5, p90: 104.9, p97: 107.3 },
  { Month: 43, p3: 92.9, p10: 95.3, p25: 97.7, p50: 100.4, p75: 103.1, p90: 105.6, p97: 108 },
  { Month: 44, p3: 93.4, p10: 95.9, p25: 98.3, p50: 101, p75: 103.8, p90: 106.2, p97: 108.6 },
  { Month: 45, p3: 93.9, p10: 96.4, p25: 98.9, p50: 101.6, p75: 104.4, p90: 106.8, p97: 109.3 },
  { Month: 46, p3: 94.4, p10: 96.9, p25: 99.4, p50: 102.2, p75: 105, p90: 107.5, p97: 109.9 },
  { Month: 47, p3: 94.9, p10: 97.4, p25: 100, p50: 102.8, p75: 105.6, p90: 108.1, p97: 110.6 },
  { Month: 48, p3: 95.4, p10: 98, p25: 100.5, p50: 103.3, p75: 106.2, p90: 108.7, p97: 111.2 },
  { Month: 49, p3: 95.9, p10: 98.5, p25: 101, p50: 103.9, p75: 106.7, p90: 109.3, p97: 111.8 },
  { Month: 50, p3: 96.4, p10: 99, p25: 101.6, p50: 104.4, p75: 107.3, p90: 109.9, p97: 112.5 },
  { Month: 51, p3: 96.9, p10: 99.5, p25: 102.1, p50: 105, p75: 107.9, p90: 110.5, p97: 113.1 },
  { Month: 52, p3: 97.4, p10: 100, p25: 102.6, p50: 105.6, p75: 108.5, p90: 111.1, p97: 113.7 },
  { Month: 53, p3: 97.9, p10: 100.5, p25: 103.2, p50: 106.1, p75: 109.1, p90: 111.7, p97: 114.3 },
  { Month: 54, p3: 98.4, p10: 101, p25: 103.7, p50: 106.7, p75: 109.6, p90: 112.3, p97: 115 },
  { Month: 55, p3: 98.8, p10: 101.5, p25: 104.2, p50: 107.2, p75: 110.2, p90: 112.9, p97: 115.6 },
  { Month: 56, p3: 99.3, p10: 102, p25: 104.7, p50: 107.8, p75: 110.8, p90: 113.5, p97: 116.2 },
  { Month: 57, p3: 99.8, p10: 102.5, p25: 105.3, p50: 108.3, p75: 111.4, p90: 114.1, p97: 116.8 },
  { Month: 58, p3: 100.3, p10: 103, p25: 105.8, p50: 108.9, p75: 111.9, p90: 114.7, p97: 117.4 },
  { Month: 59, p3: 100.8, p10: 103.5, p25: 106.3, p50: 109.4, p75: 112.5, p90: 115.3, p97: 118.1 },
  { Month: 60, p3: 101.2, p10: 104, p25: 106.8, p50: 110, p75: 113.1, p90: 115.9, p97: 118.7 },
  { Month: 66, p3: 101.6, p10: 105, p25: 108.4, p50: 111.9, p75: 115.4, p90: 119, p97: 122.7 },
  { Month: 72, p3: 104.2, p10: 107.7, p25: 111.2, p50: 114.8, p75: 118.5, p90: 122.2, p97: 126 },
  { Month: 78, p3: 106.8, p10: 110.4, p25: 114, p50: 117.8, p75: 121.6, p90: 125.4, p97: 129.3 },
  { Month: 84, p3: 109.3, p10: 113, p25: 116.8, p50: 120.7, p75: 124.6, p90: 128.6, p97: 132.6 },
  { Month: 90, p3: 111.8, p10: 115.7, p25: 119.6, p50: 123.5, p75: 127.6, p90: 131.7, p97: 135.9 },
  { Month: 96, p3: 114.3, p10: 118.2, p25: 122.3, p50: 126.4, p75: 130.5, p90: 134.8, p97: 139.1 },
  { Month: 102, p3: 116.7, p10: 120.8, p25: 124.9, p50: 129.1, p75: 133.4, p90: 137.8, p97: 142.2 },
  { Month: 108, p3: 119, p10: 123.2, p25: 127.5, p50: 131.8, p75: 136.3, p90: 140.7, p97: 145.3 },
  { Month: 114, p3: 121.3, p10: 125.6, p25: 130, p50: 134.5, p75: 139.1, p90: 143.7, p97: 148.3 },
  { Month: 120, p3: 123.6, p10: 128.1, p25: 132.6, p50: 137.2, p75: 141.9, p90: 146.6, p97: 151.4 },
  { Month: 126, p3: 125.9, p10: 130.5, p25: 135.2, p50: 139.9, p75: 144.7, p90: 149.5, p97: 154.4 },
  { Month: 132, p3: 128.2, p10: 133, p25: 137.8, p50: 142.7, p75: 147.6, p90: 152.5, p97: 157.5 },
  { Month: 138, p3: 130.7, p10: 135.6, p25: 140.6, p50: 145.5, p75: 150.5, p90: 155.6, p97: 160.6 },
  { Month: 144, p3: 133.2, p10: 138.3, p25: 143.3, p50: 148.4, p75: 153.5, p90: 158.6, p97: 163.7 },
  { Month: 150, p3: 135.7, p10: 141, p25: 146.2, p50: 151.4, p75: 156.5, p90: 161.7, p97: 166.8 },
  { Month: 156, p3: 138.3, p10: 143.7, p25: 149, p50: 154.3, p75: 159.5, p90: 164.7, p97: 169.9 },
  { Month: 162, p3: 140.9, p10: 146.4, p25: 151.8, p50: 157.2, p75: 162.4, p90: 167.6, p97: 172.7 },
  { Month: 168, p3: 143.4, p10: 149, p25: 154.5, p50: 159.9, p75: 165.1, p90: 170.3, p97: 175.4 },
  { Month: 174, p3: 145.8, p10: 151.5, p25: 157, p50: 162.3, p75: 167.6, p90: 172.7, p97: 177.7 },
  { Month: 180, p3: 148, p10: 153.7, p25: 159.2, p50: 164.5, p75: 169.7, p90: 174.8, p97: 179.7 },
  { Month: 186, p3: 150, p10: 155.7, p25: 161.2, p50: 166.5, p75: 171.6, p90: 176.5, p97: 181.4 },
  { Month: 192, p3: 151.8, p10: 157.4, p25: 162.9, p50: 168.1, p75: 173.1, p90: 178, p97: 182.7 },
  { Month: 198, p3: 153.4, p10: 159.1, p25: 164.5, p50: 169.6, p75: 174.5, p90: 179.3, p97: 183.8 },
  { Month: 204, p3: 155, p10: 160.6, p25: 165.9, p50: 171, p75: 175.8, p90: 180.4, p97: 184.8 },
  { Month: 210, p3: 156.6, p10: 162.1, p25: 167.3, p50: 172.3, p75: 177, p90: 181.5, p97: 185.8 },
  { Month: 216, p3: 158.1, p10: 163.6, p25: 168.7, p50: 173.6, p75: 178.2, p90: 182.5, p97: 186.7 }
];

// ========== 2. Girls Weight WHO IAP Blended (raw table: Month 0–60, then 66–216) ==========
const GIRLS_WEIGHT_ANCHORS = [
  { Month: 0, p3: 2.4, p10: 2.7, p25: 2.9, p50: 3.2, p75: 3.6, p90: 3.9, p97: 4.2 },
  { Month: 30, p3: 10.1, p10: 10.9, p25: 11.7, p50: 12.7, p75: 13.8, p90: 15, p97: 16.2 },
  { Month: 60, p3: 14, p10: 15.2, p25: 16.5, p50: 18.2, p75: 20.2, p90: 22.2, p97: 24.4 },
  { Month: 66, p3: 14.28, p10: 15.6, p25: 17.05, p50: 18.95, p75: 21.2, p90: 23.7, p97: 26.65 },
  { Month: 216, p3: 37.6, p10: 41.8, p25: 46.6, p50: 52, p75: 58.2, p90: 65.3, p97: 73.5 }
];
const GIRLS_WEIGHT_RAW = (() => {
  const lerp = (a, b, t) => a + t * (b - a);
  const months = [...Array.from({ length: 61 }, (_, i) => i), 66, 72, 78, 84, 90, 96, 102, 108, 114, 120, 126, 132, 138, 144, 150, 156, 162, 168, 174, 180, 186, 192, 198, 204, 210, 216];
  const pKeys = ['p3', 'p10', 'p25', 'p50', 'p75', 'p90', 'p97'];
  return months.map(m => {
    let lo, hi, t;
    if (m <= 30) {
      lo = GIRLS_WEIGHT_ANCHORS[0];
      hi = GIRLS_WEIGHT_ANCHORS[1];
      t = m === 30 ? 1 : m / 30;
    } else if (m <= 60) {
      lo = GIRLS_WEIGHT_ANCHORS[1];
      hi = GIRLS_WEIGHT_ANCHORS[2];
      t = m === 60 ? 1 : (m - 30) / 30;
    } else {
      lo = GIRLS_WEIGHT_ANCHORS[3];
      hi = GIRLS_WEIGHT_ANCHORS[4];
      t = m === 216 ? 1 : (m - 66) / (216 - 66);
    }
    return {
      Month: m,
      ...Object.fromEntries(pKeys.map((k, i) => [k, Math.round(lerp(lo[k], hi[k], t) * 10) / 10]))
    };
  });
})();

// ========== Boys Weight WHO & IAP Blended (raw table: Month 0–60, then 66–216) ==========
const BOYS_WEIGHT_ANCHORS = [
  { Month: 0, p3: 2.5, p10: 2.8, p25: 3.0, p50: 3.3, p75: 3.7, p90: 4.0, p97: 4.3 },
  { Month: 60, p3: 14.3, p10: 15.5, p25: 16.7, p50: 18.3, p75: 20.1, p90: 21.9, p97: 23.8 },
  { Month: 216, p3: 41.8, p10: 47.7, p25: 54.3, p50: 61.6, p75: 69.7, p90: 78.6, p97: 88.4 }
];
const BOYS_WEIGHT_RAW = (() => {
  const lerp = (a, b, t) => a + t * (b - a);
  const months = [...Array.from({ length: 61 }, (_, i) => i), 66, 72, 78, 84, 90, 96, 102, 108, 114, 120, 126, 132, 138, 144, 150, 156, 162, 168, 174, 180, 186, 192, 198, 204, 210, 216];
  const pKeys = ['p3', 'p10', 'p25', 'p50', 'p75', 'p90', 'p97'];
  const [a0, a60, a216] = BOYS_WEIGHT_ANCHORS;
  return months.map(m => {
    let lo, hi, t;
    if (m <= 60) {
      lo = a0;
      hi = a60;
      t = m === 60 ? 1 : m / 60;
    } else {
      lo = a60;
      hi = a216;
      t = m === 216 ? 1 : (m - 60) / (216 - 60);
    }
    return {
      Month: m,
      ...Object.fromEntries(pKeys.map(k => [k, Math.round(lerp(lo[k], hi[k], t) * 10) / 10]))
    };
  });
})();

// ========== BMI Girls 0–5 years (61 points: Month 0–60, 7 percentiles) ==========
const GIRLS_BMI_RAW = [
  { Month: 0, p3: 11.2, p10: 11.8, p25: 12.5, p50: 13.3, p75: 14.2, p90: 15, p97: 15.9 },
  { Month: 1, p3: 12.1, p10: 12.9, p25: 13.6, p50: 14.6, p75: 15.5, p90: 16.4, p97: 17.3 },
  { Month: 2, p3: 13.2, p10: 14, p25: 14.8, p50: 15.8, p75: 16.8, p90: 17.8, p97: 18.8 },
  { Month: 3, p3: 13.7, p10: 14.5, p25: 15.4, p50: 16.4, p75: 17.4, p90: 18.4, p97: 19.4 },
  { Month: 4, p3: 14, p10: 14.8, p25: 15.7, p50: 16.7, p75: 17.7, p90: 18.8, p97: 19.8 },
  { Month: 5, p3: 14.2, p10: 15, p25: 15.8, p50: 16.8, p75: 17.9, p90: 18.9, p97: 20 },
  { Month: 6, p3: 14.3, p10: 15.1, p25: 15.9, p50: 16.9, p75: 18, p90: 19, p97: 20.1 },
  { Month: 7, p3: 14.3, p10: 15.1, p25: 15.9, p50: 16.9, p75: 18, p90: 19, p97: 20.1 },
  { Month: 8, p3: 14.3, p10: 15, p25: 15.9, p50: 16.8, p75: 17.9, p90: 18.9, p97: 20 },
  { Month: 9, p3: 14.2, p10: 15, p25: 15.8, p50: 16.7, p75: 17.8, p90: 18.8, p97: 19.9 },
  { Month: 10, p3: 14.1, p10: 14.9, p25: 15.7, p50: 16.6, p75: 17.7, p90: 18.7, p97: 19.7 },
  { Month: 11, p3: 14, p10: 14.8, p25: 15.5, p50: 16.5, p75: 17.5, p90: 18.5, p97: 19.6 },
  { Month: 12, p3: 13.9, p10: 14.6, p25: 15.4, p50: 16.4, p75: 17.4, p90: 18.4, p97: 19.4 },
  { Month: 13, p3: 13.8, p10: 14.5, p25: 15.3, p50: 16.2, p75: 17.2, p90: 18.2, p97: 19.2 },
  { Month: 14, p3: 13.7, p10: 14.4, p25: 15.2, p50: 16.1, p75: 17.1, p90: 18.1, p97: 19.1 },
  { Month: 15, p3: 13.7, p10: 14.3, p25: 15.1, p50: 16, p75: 17, p90: 17.9, p97: 19 },
  { Month: 16, p3: 13.6, p10: 14.3, p25: 15, p50: 15.9, p75: 16.9, p90: 17.8, p97: 18.8 },
  { Month: 17, p3: 13.5, p10: 14.2, p25: 14.9, p50: 15.8, p75: 16.8, p90: 17.7, p97: 18.7 },
  { Month: 18, p3: 13.4, p10: 14.1, p25: 14.8, p50: 15.7, p75: 16.7, p90: 17.6, p97: 18.6 },
  { Month: 19, p3: 13.4, p10: 14.1, p25: 14.8, p50: 15.7, p75: 16.6, p90: 17.5, p97: 18.5 },
  { Month: 20, p3: 13.3, p10: 14, p25: 14.7, p50: 15.6, p75: 16.5, p90: 17.5, p97: 18.5 },
  { Month: 21, p3: 13.3, p10: 14, p25: 14.7, p50: 15.5, p75: 16.5, p90: 17.4, p97: 18.4 },
  { Month: 22, p3: 13.3, p10: 13.9, p25: 14.6, p50: 15.5, p75: 16.4, p90: 17.3, p97: 18.3 },
  { Month: 23, p3: 13.2, p10: 13.9, p25: 14.6, p50: 15.4, p75: 16.4, p90: 17.3, p97: 18.3 },
  { Month: 24, p3: 13.2, p10: 13.9, p25: 14.6, p50: 15.4, p75: 16.3, p90: 17.3, p97: 18.2 },
  { Month: 25, p3: 13.4, p10: 14.1, p25: 14.8, p50: 15.7, p75: 16.6, p90: 17.5, p97: 18.5 },
  { Month: 26, p3: 13.4, p10: 14.1, p25: 14.8, p50: 15.6, p75: 16.6, p90: 17.5, p97: 18.5 },
  { Month: 27, p3: 13.4, p10: 14, p25: 14.8, p50: 15.6, p75: 16.5, p90: 17.4, p97: 18.4 },
  { Month: 28, p3: 13.4, p10: 14, p25: 14.7, p50: 15.6, p75: 16.5, p90: 17.4, p97: 18.4 },
  { Month: 29, p3: 13.4, p10: 14, p25: 14.7, p50: 15.6, p75: 16.5, p90: 17.4, p97: 18.4 },
  { Month: 30, p3: 13.3, p10: 14, p25: 14.7, p50: 15.5, p75: 16.5, p90: 17.4, p97: 18.3 },
  { Month: 31, p3: 13.3, p10: 14, p25: 14.7, p50: 15.5, p75: 16.4, p90: 17.3, p97: 18.3 },
  { Month: 32, p3: 13.3, p10: 13.9, p25: 14.6, p50: 15.5, p75: 16.4, p90: 17.3, p97: 18.3 },
  { Month: 33, p3: 13.3, p10: 13.9, p25: 14.6, p50: 15.5, p75: 16.4, p90: 17.3, p97: 18.3 },
  { Month: 34, p3: 13.2, p10: 13.9, p25: 14.6, p50: 15.4, p75: 16.4, p90: 17.3, p97: 18.2 },
  { Month: 35, p3: 13.2, p10: 13.9, p25: 14.6, p50: 15.4, p75: 16.3, p90: 17.3, p97: 18.2 },
  { Month: 36, p3: 13.2, p10: 13.8, p25: 14.5, p50: 15.4, p75: 16.3, p90: 17.2, p97: 18.2 },
  { Month: 37, p3: 13.2, p10: 13.8, p25: 14.5, p50: 15.4, p75: 16.3, p90: 17.2, p97: 18.2 },
  { Month: 38, p3: 13.2, p10: 13.8, p25: 14.5, p50: 15.4, p75: 16.3, p90: 17.2, p97: 18.2 },
  { Month: 39, p3: 13.1, p10: 13.8, p25: 14.5, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.2 },
  { Month: 40, p3: 13.1, p10: 13.8, p25: 14.5, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.2 },
  { Month: 41, p3: 13.1, p10: 13.7, p25: 14.5, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.2 },
  { Month: 42, p3: 13.1, p10: 13.7, p25: 14.4, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.2 },
  { Month: 43, p3: 13, p10: 13.7, p25: 14.4, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.2 },
  { Month: 44, p3: 13, p10: 13.7, p25: 14.4, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.2 },
  { Month: 45, p3: 13, p10: 13.7, p25: 14.4, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.3 },
  { Month: 46, p3: 13, p10: 13.7, p25: 14.4, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.3 },
  { Month: 47, p3: 13, p10: 13.6, p25: 14.4, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.3 },
  { Month: 48, p3: 12.9, p10: 13.6, p25: 14.4, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.3 },
  { Month: 49, p3: 12.9, p10: 13.6, p25: 14.4, p50: 15.3, p75: 16.3, p90: 17.2, p97: 18.3 },
  { Month: 50, p3: 12.9, p10: 13.6, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.3, p97: 18.3 },
  { Month: 51, p3: 12.9, p10: 13.6, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.3, p97: 18.4 },
  { Month: 52, p3: 12.9, p10: 13.6, p25: 14.3, p50: 15.2, p75: 16.3, p90: 17.3, p97: 18.4 },
  { Month: 53, p3: 12.9, p10: 13.6, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.3, p97: 18.4 },
  { Month: 54, p3: 12.9, p10: 13.6, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.3, p97: 18.4 },
  { Month: 55, p3: 12.9, p10: 13.5, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.3, p97: 18.4 },
  { Month: 56, p3: 12.8, p10: 13.5, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.3, p97: 18.5 },
  { Month: 57, p3: 12.8, p10: 13.5, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.4, p97: 18.5 },
  { Month: 58, p3: 12.8, p10: 13.5, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.4, p97: 18.5 },
  { Month: 59, p3: 12.8, p10: 13.5, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.4, p97: 18.5 },
  { Month: 60, p3: 12.8, p10: 13.5, p25: 14.3, p50: 15.3, p75: 16.3, p90: 17.4, p97: 18.6 }
];

// ========== BMI Boys 0–5 years (61 points: Month 0–60, 7 percentiles) ==========
const BOYS_BMI_RAW = [
  { Month: 0, p3: 11.3, p10: 11.9, p25: 12.6, p50: 13.4, p75: 14.3, p90: 15.2, p97: 16.1 },
  { Month: 1, p3: 12.6, p10: 13.3, p25: 14.1, p50: 14.9, p75: 15.9, p90: 16.7, p97: 17.6 },
  { Month: 2, p3: 13.8, p10: 14.6, p25: 15.4, p50: 16.3, p75: 17.3, p90: 18.2, p97: 19.2 },
  { Month: 3, p3: 14.4, p10: 15.2, p25: 16, p50: 16.9, p75: 17.9, p90: 18.8, p97: 19.8 },
  { Month: 4, p3: 14.7, p10: 15.4, p25: 16.2, p50: 17.2, p75: 18.2, p90: 19.1, p97: 20.1 },
  { Month: 5, p3: 14.8, p10: 15.6, p25: 16.4, p50: 17.3, p75: 18.3, p90: 19.2, p97: 20.2 },
  { Month: 6, p3: 14.9, p10: 15.6, p25: 16.4, p50: 17.3, p75: 18.3, p90: 19.3, p97: 20.3 },
  { Month: 7, p3: 14.9, p10: 15.6, p25: 16.4, p50: 17.3, p75: 18.3, p90: 19.3, p97: 20.3 },
  { Month: 8, p3: 14.9, p10: 15.6, p25: 16.3, p50: 17.3, p75: 18.2, p90: 19.2, p97: 20.2 },
  { Month: 9, p3: 14.8, p10: 15.5, p25: 16.3, p50: 17.2, p75: 18.1, p90: 19.1, p97: 20.1 },
  { Month: 10, p3: 14.7, p10: 15.4, p25: 16.2, p50: 17, p75: 18, p90: 18.9, p97: 19.9 },
  { Month: 11, p3: 14.6, p10: 15.3, p25: 16, p50: 16.9, p75: 17.9, p90: 18.8, p97: 19.8 },
  { Month: 12, p3: 14.5, p10: 15.2, p25: 15.9, p50: 16.8, p75: 17.7, p90: 18.7, p97: 19.6 },
  { Month: 13, p3: 14.4, p10: 15.1, p25: 15.8, p50: 16.7, p75: 17.6, p90: 18.5, p97: 19.5 },
  { Month: 14, p3: 14.3, p10: 15, p25: 15.7, p50: 16.6, p75: 17.5, p90: 18.4, p97: 19.3 },
  { Month: 15, p3: 14.2, p10: 14.9, p25: 15.6, p50: 16.4, p75: 17.4, p90: 18.2, p97: 19.2 },
  { Month: 16, p3: 14.2, p10: 14.8, p25: 15.5, p50: 16.3, p75: 17.2, p90: 18.1, p97: 19.1 },
  { Month: 17, p3: 14.1, p10: 14.7, p25: 15.4, p50: 16.2, p75: 17.1, p90: 18, p97: 18.9 },
  { Month: 18, p3: 14, p10: 14.6, p25: 15.3, p50: 16.1, p75: 17, p90: 17.9, p97: 18.8 },
  { Month: 19, p3: 13.9, p10: 14.6, p25: 15.2, p50: 16.1, p75: 16.9, p90: 17.8, p97: 18.7 },
  { Month: 20, p3: 13.9, p10: 14.5, p25: 15.2, p50: 16, p75: 16.9, p90: 17.7, p97: 18.6 },
  { Month: 21, p3: 13.8, p10: 14.4, p25: 15.1, p50: 15.9, p75: 16.8, p90: 17.6, p97: 18.6 },
  { Month: 22, p3: 13.8, p10: 14.4, p25: 15, p50: 15.8, p75: 16.7, p90: 17.6, p97: 18.5 },
  { Month: 23, p3: 13.7, p10: 14.3, p25: 15, p50: 15.8, p75: 16.7, p90: 17.5, p97: 18.4 },
  { Month: 24, p3: 13.7, p10: 14.3, p25: 14.9, p50: 15.7, p75: 16.6, p90: 17.4, p97: 18.3 },
  { Month: 25, p3: 13.9, p10: 14.5, p25: 15.2, p50: 16, p75: 16.9, p90: 17.7, p97: 18.6 },
  { Month: 26, p3: 13.8, p10: 14.5, p25: 15.1, p50: 15.9, p75: 16.8, p90: 17.7, p97: 18.6 },
  { Month: 27, p3: 13.8, p10: 14.4, p25: 15.1, p50: 15.9, p75: 16.8, p90: 17.6, p97: 18.5 },
  { Month: 28, p3: 13.8, p10: 14.4, p25: 15.1, p50: 15.9, p75: 16.7, p90: 17.6, p97: 18.5 },
  { Month: 29, p3: 13.7, p10: 14.4, p25: 15, p50: 15.8, p75: 16.7, p90: 17.5, p97: 18.4 },
  { Month: 30, p3: 13.7, p10: 14.3, p25: 15, p50: 15.8, p75: 16.7, p90: 17.5, p97: 18.4 },
  { Month: 31, p3: 13.7, p10: 14.3, p25: 15, p50: 15.8, p75: 16.6, p90: 17.5, p97: 18.4 },
  { Month: 32, p3: 13.6, p10: 14.2, p25: 14.9, p50: 15.7, p75: 16.6, p90: 17.4, p97: 18.3 },
  { Month: 33, p3: 13.6, p10: 14.2, p25: 14.9, p50: 15.7, p75: 16.6, p90: 17.4, p97: 18.3 },
  { Month: 34, p3: 13.5, p10: 14.2, p25: 14.9, p50: 15.7, p75: 16.5, p90: 17.4, p97: 18.2 },
  { Month: 35, p3: 13.5, p10: 14.1, p25: 14.8, p50: 15.6, p75: 16.5, p90: 17.3, p97: 18.2 },
  { Month: 36, p3: 13.5, p10: 14.1, p25: 14.8, p50: 15.6, p75: 16.5, p90: 17.3, p97: 18.2 },
  { Month: 37, p3: 13.5, p10: 14.1, p25: 14.8, p50: 15.6, p75: 16.4, p90: 17.3, p97: 18.1 },
  { Month: 38, p3: 13.4, p10: 14.1, p25: 14.7, p50: 15.5, p75: 16.4, p90: 17.2, p97: 18.1 },
  { Month: 39, p3: 13.4, p10: 14, p25: 14.7, p50: 15.5, p75: 16.4, p90: 17.2, p97: 18.1 },
  { Month: 40, p3: 13.4, p10: 14, p25: 14.7, p50: 15.5, p75: 16.4, p90: 17.2, p97: 18.1 },
  { Month: 41, p3: 13.3, p10: 14, p25: 14.7, p50: 15.5, p75: 16.3, p90: 17.2, p97: 18 },
  { Month: 42, p3: 13.3, p10: 13.9, p25: 14.6, p50: 15.4, p75: 16.3, p90: 17.1, p97: 18 },
  { Month: 43, p3: 13.3, p10: 13.9, p25: 14.6, p50: 15.4, p75: 16.3, p90: 17.1, p97: 18 },
  { Month: 44, p3: 13.3, p10: 13.9, p25: 14.6, p50: 15.4, p75: 16.3, p90: 17.1, p97: 18 },
  { Month: 45, p3: 13.2, p10: 13.9, p25: 14.6, p50: 15.4, p75: 16.3, p90: 17.1, p97: 18 },
  { Month: 46, p3: 13.2, p10: 13.9, p25: 14.5, p50: 15.4, p75: 16.2, p90: 17.1, p97: 18 },
  { Month: 47, p3: 13.2, p10: 13.8, p25: 14.5, p50: 15.3, p75: 16.2, p90: 17.1, p97: 18 },
  { Month: 48, p3: 13.2, p10: 13.8, p25: 14.5, p50: 15.3, p75: 16.2, p90: 17.1, p97: 18 },
  { Month: 49, p3: 13.2, p10: 13.8, p25: 14.5, p50: 15.3, p75: 16.2, p90: 17.1, p97: 18 },
  { Month: 50, p3: 13.2, p10: 13.8, p25: 14.5, p50: 15.3, p75: 16.2, p90: 17.1, p97: 18 },
  { Month: 51, p3: 13.1, p10: 13.8, p25: 14.5, p50: 15.3, p75: 16.2, p90: 17.1, p97: 18 },
  { Month: 52, p3: 13.1, p10: 13.8, p25: 14.4, p50: 15.3, p75: 16.2, p90: 17.1, p97: 18 },
  { Month: 53, p3: 13.1, p10: 13.7, p25: 14.4, p50: 15.3, p75: 16.2, p90: 17.1, p97: 18 },
  { Month: 54, p3: 13.1, p10: 13.7, p25: 14.4, p50: 15.3, p75: 16.2, p90: 17, p97: 18 },
  { Month: 55, p3: 13.1, p10: 13.7, p25: 14.4, p50: 15.2, p75: 16.2, p90: 17, p97: 18 },
  { Month: 56, p3: 13.1, p10: 13.7, p25: 14.4, p50: 15.2, p75: 16.1, p90: 17, p97: 18 },
  { Month: 57, p3: 13, p10: 13.7, p25: 14.4, p50: 15.2, p75: 16.1, p90: 17.1, p97: 18 },
  { Month: 58, p3: 13, p10: 13.7, p25: 14.4, p50: 15.2, p75: 16.1, p90: 17.1, p97: 18 },
  { Month: 59, p3: 13, p10: 13.7, p25: 14.4, p50: 15.2, p75: 16.1, p90: 17.1, p97: 18.1 },
  { Month: 60, p3: 13, p10: 13.6, p25: 14.3, p50: 15.2, p75: 16.1, p90: 17.1, p97: 18.1 }
];

// ========== Head circumference (HCFA) Boys 0–5 years (61 points: Month 0–60, 7 percentiles) ==========
const BOYS_HC_RAW = [
  { Month: 0, p3: 32.1, p10: 32.8, p25: 33.6, p50: 34.5, p75: 35.3, p90: 36.1, p97: 36.9 },
  { Month: 1, p3: 35.1, p10: 35.8, p25: 36.5, p50: 37.3, p75: 38.1, p90: 38.8, p97: 39.5 },
  { Month: 2, p3: 36.9, p10: 37.6, p25: 38.3, p50: 39.1, p75: 39.9, p90: 40.6, p97: 41.3 },
  { Month: 3, p3: 38.3, p10: 39, p25: 39.7, p50: 40.5, p75: 41.3, p90: 42, p97: 42.7 },
  { Month: 4, p3: 39.4, p10: 40.1, p25: 40.8, p50: 41.6, p75: 42.4, p90: 43.2, p97: 43.9 },
  { Month: 5, p3: 40.3, p10: 41, p25: 41.7, p50: 42.6, p75: 43.4, p90: 44.1, p97: 44.8 },
  { Month: 6, p3: 41, p10: 41.8, p25: 42.5, p50: 43.3, p75: 44.2, p90: 44.9, p97: 45.6 },
  { Month: 7, p3: 41.7, p10: 42.4, p25: 43.1, p50: 44, p75: 44.8, p90: 45.6, p97: 46.3 },
  { Month: 8, p3: 42.2, p10: 42.9, p25: 43.7, p50: 44.5, p75: 45.4, p90: 46.1, p97: 46.9 },
  { Month: 9, p3: 42.6, p10: 43.4, p25: 44.2, p50: 45, p75: 45.8, p90: 46.6, p97: 47.4 },
  { Month: 10, p3: 43, p10: 43.8, p25: 44.6, p50: 45.4, p75: 46.3, p90: 47, p97: 47.8 },
  { Month: 11, p3: 43.4, p10: 44.1, p25: 44.9, p50: 45.8, p75: 46.6, p90: 47.4, p97: 48.2 },
  { Month: 12, p3: 43.6, p10: 44.4, p25: 45.2, p50: 46.1, p75: 46.9, p90: 47.7, p97: 48.5 },
  { Month: 13, p3: 43.9, p10: 44.7, p25: 45.5, p50: 46.3, p75: 47.2, p90: 48, p97: 48.8 },
  { Month: 14, p3: 44.1, p10: 44.9, p25: 45.7, p50: 46.6, p75: 47.5, p90: 48.3, p97: 49 },
  { Month: 15, p3: 44.3, p10: 45.1, p25: 45.9, p50: 46.8, p75: 47.7, p90: 48.5, p97: 49.3 },
  { Month: 16, p3: 44.5, p10: 45.3, p25: 46.1, p50: 47, p75: 47.9, p90: 48.7, p97: 49.5 },
  { Month: 17, p3: 44.7, p10: 45.5, p25: 46.3, p50: 47.2, p75: 48.1, p90: 48.9, p97: 49.7 },
  { Month: 18, p3: 44.9, p10: 45.7, p25: 46.5, p50: 47.4, p75: 48.3, p90: 49.1, p97: 49.9 },
  { Month: 19, p3: 45, p10: 45.8, p25: 46.6, p50: 47.5, p75: 48.4, p90: 49.2, p97: 50 },
  { Month: 20, p3: 45.2, p10: 46, p25: 46.8, p50: 47.7, p75: 48.6, p90: 49.4, p97: 50.2 },
  { Month: 21, p3: 45.3, p10: 46.1, p25: 46.9, p50: 47.8, p75: 48.7, p90: 49.6, p97: 50.4 },
  { Month: 22, p3: 45.4, p10: 46.3, p25: 47.1, p50: 48, p75: 48.9, p90: 49.7, p97: 50.5 },
  { Month: 23, p3: 45.6, p10: 46.4, p25: 47.2, p50: 48.1, p75: 49, p90: 49.9, p97: 50.7 },
  { Month: 24, p3: 45.7, p10: 46.5, p25: 47.3, p50: 48.3, p75: 49.2, p90: 50, p97: 50.8 },
  { Month: 25, p3: 45.8, p10: 46.6, p25: 47.5, p50: 48.4, p75: 49.3, p90: 50.1, p97: 50.9 },
  { Month: 26, p3: 45.9, p10: 46.7, p25: 47.6, p50: 48.5, p75: 49.4, p90: 50.3, p97: 51.1 },
  { Month: 27, p3: 46, p10: 46.8, p25: 47.7, p50: 48.6, p75: 49.5, p90: 50.4, p97: 51.2 },
  { Month: 28, p3: 46.1, p10: 47, p25: 47.8, p50: 48.7, p75: 49.7, p90: 50.5, p97: 51.3 },
  { Month: 29, p3: 46.2, p10: 47.1, p25: 47.9, p50: 48.8, p75: 49.8, p90: 50.6, p97: 51.4 },
  { Month: 30, p3: 46.3, p10: 47.1, p25: 48, p50: 48.9, p75: 49.9, p90: 50.7, p97: 51.6 },
  { Month: 31, p3: 46.4, p10: 47.2, p25: 48.1, p50: 49, p75: 50, p90: 50.8, p97: 51.7 },
  { Month: 32, p3: 46.5, p10: 47.3, p25: 48.2, p50: 49.1, p75: 50.1, p90: 50.9, p97: 51.8 },
  { Month: 33, p3: 46.6, p10: 47.4, p25: 48.3, p50: 49.2, p75: 50.2, p90: 51, p97: 51.9 },
  { Month: 34, p3: 46.6, p10: 47.5, p25: 48.3, p50: 49.3, p75: 50.3, p90: 51.1, p97: 52 },
  { Month: 35, p3: 46.7, p10: 47.6, p25: 48.4, p50: 49.4, p75: 50.3, p90: 51.2, p97: 52 },
  { Month: 36, p3: 46.8, p10: 47.6, p25: 48.5, p50: 49.5, p75: 50.4, p90: 51.3, p97: 52.1 },
  { Month: 37, p3: 46.9, p10: 47.7, p25: 48.6, p50: 49.5, p75: 50.5, p90: 51.4, p97: 52.2 },
  { Month: 38, p3: 46.9, p10: 47.8, p25: 48.6, p50: 49.6, p75: 50.6, p90: 51.4, p97: 52.3 },
  { Month: 39, p3: 47, p10: 47.8, p25: 48.7, p50: 49.7, p75: 50.6, p90: 51.5, p97: 52.4 },
  { Month: 40, p3: 47, p10: 47.9, p25: 48.8, p50: 49.7, p75: 50.7, p90: 51.6, p97: 52.4 },
  { Month: 41, p3: 47.1, p10: 48, p25: 48.8, p50: 49.8, p75: 50.8, p90: 51.7, p97: 52.5 },
  { Month: 42, p3: 47.2, p10: 48, p25: 48.9, p50: 49.9, p75: 50.8, p90: 51.7, p97: 52.6 },
  { Month: 43, p3: 47.2, p10: 48.1, p25: 49, p50: 49.9, p75: 50.9, p90: 51.8, p97: 52.7 },
  { Month: 44, p3: 47.3, p10: 48.1, p25: 49, p50: 50, p75: 51, p90: 51.9, p97: 52.7 },
  { Month: 45, p3: 47.3, p10: 48.2, p25: 49.1, p50: 50.1, p75: 51, p90: 51.9, p97: 52.8 },
  { Month: 46, p3: 47.4, p10: 48.2, p25: 49.1, p50: 50.1, p75: 51.1, p90: 52, p97: 52.8 },
  { Month: 47, p3: 47.4, p10: 48.3, p25: 49.2, p50: 50.2, p75: 51.1, p90: 52, p97: 52.9 },
  { Month: 48, p3: 47.5, p10: 48.3, p25: 49.2, p50: 50.2, p75: 51.2, p90: 52.1, p97: 53 },
  { Month: 49, p3: 47.5, p10: 48.4, p25: 49.3, p50: 50.3, p75: 51.2, p90: 52.1, p97: 53 },
  { Month: 50, p3: 47.5, p10: 48.4, p25: 49.3, p50: 50.3, p75: 51.3, p90: 52.2, p97: 53.1 },
  { Month: 51, p3: 47.6, p10: 48.5, p25: 49.4, p50: 50.4, p75: 51.3, p90: 52.2, p97: 53.1 },
  { Month: 52, p3: 47.6, p10: 48.5, p25: 49.4, p50: 50.4, p75: 51.4, p90: 52.3, p97: 53.2 },
  { Month: 53, p3: 47.7, p10: 48.6, p25: 49.5, p50: 50.4, p75: 51.4, p90: 52.3, p97: 53.2 },
  { Month: 54, p3: 47.7, p10: 48.6, p25: 49.5, p50: 50.5, p75: 51.5, p90: 52.4, p97: 53.3 },
  { Month: 55, p3: 47.7, p10: 48.6, p25: 49.5, p50: 50.5, p75: 51.5, p90: 52.4, p97: 53.3 },
  { Month: 56, p3: 47.8, p10: 48.7, p25: 49.6, p50: 50.6, p75: 51.6, p90: 52.5, p97: 53.4 },
  { Month: 57, p3: 47.8, p10: 48.7, p25: 49.6, p50: 50.6, p75: 51.6, p90: 52.5, p97: 53.4 },
  { Month: 58, p3: 47.9, p10: 48.8, p25: 49.7, p50: 50.7, p75: 51.7, p90: 52.6, p97: 53.5 },
  { Month: 59, p3: 47.9, p10: 48.8, p25: 49.7, p50: 50.7, p75: 51.7, p90: 52.6, p97: 53.5 },
  { Month: 60, p3: 47.9, p10: 48.8, p25: 49.7, p50: 50.7, p75: 51.7, p90: 52.7, p97: 53.5 }
];

// ========== Head circumference (HCFA) Girls 0–5 years (61 points: Month 0–60, 7 percentiles) ==========
const GIRLS_HC_RAW = [
  { Month: 0, p3: 31.7, p10: 32.4, p25: 33.1, p50: 33.9, p75: 34.7, p90: 35.4, p97: 36.1 },
  { Month: 1, p3: 34.3, p10: 35, p25: 35.8, p50: 36.5, p75: 37.3, p90: 38, p97: 38.8 },
  { Month: 2, p3: 36, p10: 36.7, p25: 37.4, p50: 38.3, p75: 39.1, p90: 39.8, p97: 40.5 },
  { Month: 3, p3: 37.2, p10: 37.9, p25: 38.7, p50: 39.5, p75: 40.4, p90: 41.1, p97: 41.9 },
  { Month: 4, p3: 38.2, p10: 39, p25: 39.7, p50: 40.6, p75: 41.4, p90: 42.2, p97: 43 },
  { Month: 5, p3: 39, p10: 39.8, p25: 40.6, p50: 41.5, p75: 42.3, p90: 43.1, p97: 43.9 },
  { Month: 6, p3: 39.7, p10: 40.5, p25: 41.3, p50: 42.2, p75: 43.1, p90: 43.9, p97: 44.6 },
  { Month: 7, p3: 40.4, p10: 41.1, p25: 41.9, p50: 42.8, p75: 43.7, p90: 44.5, p97: 45.3 },
  { Month: 8, p3: 40.9, p10: 41.7, p25: 42.5, p50: 43.4, p75: 44.3, p90: 45.1, p97: 45.9 },
  { Month: 9, p3: 41.3, p10: 42.1, p25: 42.9, p50: 43.8, p75: 44.7, p90: 45.5, p97: 46.3 },
  { Month: 10, p3: 41.7, p10: 42.5, p25: 43.3, p50: 44.2, p75: 45.1, p90: 46, p97: 46.8 },
  { Month: 11, p3: 42, p10: 42.9, p25: 43.7, p50: 44.6, p75: 45.5, p90: 46.3, p97: 47.1 },
  { Month: 12, p3: 42.3, p10: 43.2, p25: 44, p50: 44.9, p75: 45.8, p90: 46.6, p97: 47.5 },
  { Month: 13, p3: 42.6, p10: 43.4, p25: 44.3, p50: 45.2, p75: 46.1, p90: 46.9, p97: 47.7 },
  { Month: 14, p3: 42.9, p10: 43.7, p25: 44.5, p50: 45.4, p75: 46.3, p90: 47.2, p97: 48 },
  { Month: 15, p3: 43.1, p10: 43.9, p25: 44.7, p50: 45.7, p75: 46.6, p90: 47.4, p97: 48.2 },
  { Month: 16, p3: 43.3, p10: 44.1, p25: 44.9, p50: 45.9, p75: 46.8, p90: 47.6, p97: 48.5 },
  { Month: 17, p3: 43.5, p10: 44.3, p25: 45.1, p50: 46.1, p75: 47, p90: 47.8, p97: 48.7 },
  { Month: 18, p3: 43.6, p10: 44.5, p25: 45.3, p50: 46.2, p75: 47.2, p90: 48, p97: 48.8 },
  { Month: 19, p3: 43.8, p10: 44.6, p25: 45.5, p50: 46.4, p75: 47.3, p90: 48.2, p97: 49 },
  { Month: 20, p3: 44, p10: 44.8, p25: 45.6, p50: 46.6, p75: 47.5, p90: 48.4, p97: 49.2 },
  { Month: 21, p3: 44.1, p10: 45, p25: 45.8, p50: 46.7, p75: 47.7, p90: 48.5, p97: 49.4 },
  { Month: 22, p3: 44.3, p10: 45.1, p25: 46, p50: 46.9, p75: 47.8, p90: 48.7, p97: 49.5 },
  { Month: 23, p3: 44.4, p10: 45.3, p25: 46.1, p50: 47, p75: 48, p90: 48.8, p97: 49.7 },
  { Month: 24, p3: 44.6, p10: 45.4, p25: 46.2, p50: 47.2, p75: 48.1, p90: 49, p97: 49.8 },
  { Month: 25, p3: 44.7, p10: 45.5, p25: 46.4, p50: 47.3, p75: 48.3, p90: 49.1, p97: 49.9 },
  { Month: 26, p3: 44.8, p10: 45.7, p25: 46.5, p50: 47.5, p75: 48.4, p90: 49.2, p97: 50.1 },
  { Month: 27, p3: 44.9, p10: 45.8, p25: 46.6, p50: 47.6, p75: 48.5, p90: 49.4, p97: 50.2 },
  { Month: 28, p3: 45.1, p10: 45.9, p25: 46.8, p50: 47.7, p75: 48.7, p90: 49.5, p97: 50.3 },
  { Month: 29, p3: 45.2, p10: 46, p25: 46.9, p50: 47.8, p75: 48.8, p90: 49.6, p97: 50.5 },
  { Month: 30, p3: 45.3, p10: 46.1, p25: 47, p50: 47.9, p75: 48.9, p90: 49.7, p97: 50.6 },
  { Month: 31, p3: 45.4, p10: 46.2, p25: 47.1, p50: 48, p75: 49, p90: 49.8, p97: 50.7 },
  { Month: 32, p3: 45.5, p10: 46.3, p25: 47.2, p50: 48.1, p75: 49.1, p90: 49.9, p97: 50.8 },
  { Month: 33, p3: 45.6, p10: 46.4, p25: 47.3, p50: 48.2, p75: 49.2, p90: 50, p97: 50.9 },
  { Month: 34, p3: 45.7, p10: 46.5, p25: 47.4, p50: 48.3, p75: 49.3, p90: 50.1, p97: 51 },
  { Month: 35, p3: 45.8, p10: 46.6, p25: 47.5, p50: 48.4, p75: 49.4, p90: 50.2, p97: 51.1 },
  { Month: 36, p3: 45.9, p10: 46.7, p25: 47.6, p50: 48.5, p75: 49.5, p90: 50.3, p97: 51.2 },
  { Month: 37, p3: 45.9, p10: 46.8, p25: 47.6, p50: 48.6, p75: 49.5, p90: 50.4, p97: 51.3 },
  { Month: 38, p3: 46, p10: 46.9, p25: 47.7, p50: 48.7, p75: 49.6, p90: 50.5, p97: 51.4 },
  { Month: 39, p3: 46.1, p10: 46.9, p25: 47.8, p50: 48.7, p75: 49.7, p90: 50.6, p97: 51.4 },
  { Month: 40, p3: 46.2, p10: 47, p25: 47.9, p50: 48.8, p75: 49.8, p90: 50.6, p97: 51.5 },
  { Month: 41, p3: 46.2, p10: 47.1, p25: 47.9, p50: 48.9, p75: 49.8, p90: 50.7, p97: 51.6 },
  { Month: 42, p3: 46.3, p10: 47.1, p25: 48, p50: 49, p75: 49.9, p90: 50.8, p97: 51.6 },
  { Month: 43, p3: 46.4, p10: 47.2, p25: 48.1, p50: 49, p75: 50, p90: 50.8, p97: 51.7 },
  { Month: 44, p3: 46.4, p10: 47.3, p25: 48.1, p50: 49.1, p75: 50.1, p90: 50.9, p97: 51.8 },
  { Month: 45, p3: 46.5, p10: 47.3, p25: 48.2, p50: 49.2, p75: 50.1, p90: 51, p97: 51.8 },
  { Month: 46, p3: 46.5, p10: 47.4, p25: 48.3, p50: 49.2, p75: 50.2, p90: 51, p97: 51.9 },
  { Month: 47, p3: 46.6, p10: 47.5, p25: 48.3, p50: 49.3, p75: 50.2, p90: 51.1, p97: 51.9 },
  { Month: 48, p3: 46.7, p10: 47.5, p25: 48.4, p50: 49.3, p75: 50.3, p90: 51.2, p97: 52 },
  { Month: 49, p3: 46.7, p10: 47.6, p25: 48.4, p50: 49.4, p75: 50.3, p90: 51.2, p97: 52.1 },
  { Month: 50, p3: 46.8, p10: 47.6, p25: 48.5, p50: 49.4, p75: 50.4, p90: 51.3, p97: 52.1 },
  { Month: 51, p3: 46.8, p10: 47.7, p25: 48.5, p50: 49.5, p75: 50.5, p90: 51.3, p97: 52.2 },
  { Month: 52, p3: 46.9, p10: 47.7, p25: 48.6, p50: 49.5, p75: 50.5, p90: 51.4, p97: 52.2 },
  { Month: 53, p3: 46.9, p10: 47.8, p25: 48.6, p50: 49.6, p75: 50.6, p90: 51.4, p97: 52.3 },
  { Month: 54, p3: 47, p10: 47.8, p25: 48.7, p50: 49.6, p75: 50.6, p90: 51.5, p97: 52.3 },
  { Month: 55, p3: 47, p10: 47.9, p25: 48.7, p50: 49.7, p75: 50.7, p90: 51.5, p97: 52.4 },
  { Month: 56, p3: 47.1, p10: 47.9, p25: 48.8, p50: 49.7, p75: 50.7, p90: 51.6, p97: 52.4 },
  { Month: 57, p3: 47.1, p10: 48, p25: 48.8, p50: 49.8, p75: 50.7, p90: 51.6, p97: 52.5 },
  { Month: 58, p3: 47.2, p10: 48, p25: 48.9, p50: 49.8, p75: 50.8, p90: 51.7, p97: 52.5 },
  { Month: 59, p3: 47.2, p10: 48.1, p25: 48.9, p50: 49.9, p75: 50.8, p90: 51.7, p97: 52.6 },
  { Month: 60, p3: 47.2, p10: 48.1, p25: 49, p50: 49.9, p75: 50.9, p90: 51.7, p97: 52.6 }
];

export function getStandardGrowthCurves(gender, type) {
  const isMale = (gender || '').toString().toLowerCase() === 'm';
  if (type === 'height') {
    const raw = isMale ? BOYS_HEIGHT_RAW : GIRLS_HEIGHT_RAW;
    return buildFromRawTable(raw);
  }
  if (type === 'weight') {
    const raw = isMale ? BOYS_WEIGHT_RAW : GIRLS_WEIGHT_RAW;
    return buildFromRawTable(raw);
  }
  if (type === 'bmi') {
    const raw = isMale ? BOYS_BMI_RAW : GIRLS_BMI_RAW;
    return buildFromRawTable(raw);
  }
  if (type === 'head circumference') {
    const raw = isMale ? BOYS_HC_RAW : GIRLS_HC_RAW;
    return buildFromRawTable(raw);
  }
  return { ages: [], curves: [] };
}
